let parameters = {
    namespace: {
        label: 'Namespace',
        class: 'xs12 sm12 d-flex',
        type: 'input',
        value: ''
    },
    namespaceDescription: {
        label: 'Namespace Description',
        class: 'xs12 sm12 d-flex',
        type: 'input',
        value: 'My Documents'
    },
    buttonMenu: {
        label: 'Button Menu',
        class: 'xs12 sm12',
        type: 'textarea',
        value: ""
    }
};

export default parameters;
